import React, { Component } from 'react'
import classNames from 'classnames'
import debounce from 'lodash/debounce'

class LoadingIndicator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      percentage: 0,
      animating: false,
    }
  }

  componentWillUnmount() {
    clearTimeout(this.trickleTimeout)
  }

  // We are debouncing this method by 700ms to ensure that the loading indicator
  // only gets shown when the load time is perceptible to the user.
  start = debounce(() => {
    // We are checking `numberOfActiveRequests` again because it could have gone
    // to zero since we queued up this debounced method.
    if (this.props.numberOfActiveRequests) {
      this.setState({ percentage: 0, animating: true }, this.trickle)
    }
  }, 700)

  componentDidUpdate(prevProps, prevState) {
    // Start the animation loop if we have active requests and the animation
    // loop hasn't started yet.
    if (this.props.numberOfActiveRequests && !this.state.animating) {
      this.start()
    }

    // Once all the active requests finish (and the animation loop is running),
    // set the percentage to 100 to fill out the progress bar.
    if (
      prevProps.numberOfActiveRequests &&
      !this.props.numberOfActiveRequests &&
      this.state.animating
    ) {
      clearTimeout(this.trickleTimeout)
      this.setState({ percentage: 100 })
    }

    // Once loading indicator is visually full, reset it back to 0.
    if (prevState.percentage !== this.state.percentage && this.state.percentage == 100) {
      setTimeout(() => {
        clearTimeout(this.trickleTimeout)
        this.setState({ animating: false, percentage: 0 })
      }, 500)
    }
  }

  trickle() {
    if (!this.props.numberOfActiveRequests) {
      return
    }

    const { percentage: currentPercentage } = this.state

    // We are using a dynamic multipler to generate the progress
    // delta so as the loading bar approaches 100%, we can
    // increment it in increasingly smaller amounts.
    const incrementAmount =
      (50 / this.props.numberOfActiveRequests) * this.multiplier * Math.random()
    const newPercentage = Math.floor(Math.min(currentPercentage + incrementAmount, 98))

    // Update after a timeout, which should be ~300ms, randomized to provide realness.
    let timeToUpdate
    if (currentPercentage > 0) {
      timeToUpdate = Math.floor(Math.random() * 200) + 100
    } else {
      // fire immediately the first time
      timeToUpdate = 0
    }

    this.trickleTimeout = setTimeout(() => {
      this.setState({ percentage: newPercentage })
      requestAnimationFrame(() => this.trickle())
    }, timeToUpdate)
  }

  // This makes it so as the progress bar nears completion, it will grow
  // in smaller and smaller increments, approaching 1.
  get multiplier() {
    const { percentage } = this.state
    let multiplier = 0

    if (percentage < 50) {
      multiplier = 0.9
    } else if (percentage < 80) {
      multiplier = 0.5
    } else if (percentage < 90) {
      multiplier = 0.2
    }

    return multiplier
  }

  render() {
    return (
      <div
        className={classNames('loading-indicator', {
          'loading-indicator--active': !!this.props.numberOfActiveRequests,
          'loading-indicator--hidden': this.state.percentage === 0,
          'loading-indicator--complete': this.state.percentage === 100,
        })}
        style={{
          width: `${this.state.percentage}%`,
        }}
      />
    )
  }
}
export default LoadingIndicator
